import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "user-interface"
    }}>{`User Interface`}</h1>
    <p>{`Your add-on's user interface should provide a great user experience.`}</p>
    <h2 {...{
      "id": "your-add-on-design"
    }}>{`Your add-on design`}</h2>
    <p>{`When it comes to design, create a layout that aligns with the functionality of your add-on.`}</p>
    <p>{`However, remember that your users will be accessing your add-on as part of their Adobe Express workflow - so try to make sure they can move seamlessly without coming across anything jarring or counter-intuitive.`}</p>
    <p>{`We highly suggest leveraging the Spectrum Design System and Spectrum Express theme to create user interfaces that feel similar to the Adobe Express user interface.`}</p>
    <p>{`We’ve included these guidelines here to help you create a great experience for users. Also refer to our `}<a parentName="p" {...{
        "href": "../../../design/index.md"
      }}>{`User interface design guide`}</a>{`, which includes a comprehensive set of `}<a parentName="p" {...{
        "href": "../../../design/ux_guidelines/introduction.md"
      }}>{`UX Guidelines`}</a>{` to help with your add-on design.`}</p>
    <h2 {...{
      "id": "display-items"
    }}>{`Display Items`}</h2>
    <p>{`Here are some tips to assist with the layout of your add-on, from display to icons.`}</p>
    <h3 {...{
      "id": "empty-screens"
    }}>{`Empty screens`}</h3>
    <p>{`You should avoid including any empty screens in your design. All screens within your add-on should feature at least some information.`}</p>
    <h3 {...{
      "id": "scroll-bars"
    }}>{`Scroll bars`}</h3>
    <p>{`If your content does not fully fit on a single screen, you should make it clear that the user can scroll to view the remaining content.`}</p>
    <h3 {...{
      "id": "buttons"
    }}>{`Buttons`}</h3>
    <p>{`All add-on buttons should be displayed correctly, and not overlap with each other.`}</p>
    <h3 {...{
      "id": "changing-between-languages"
    }}>{`Changing between languages`}</h3>
    <p>{`The user interface should still be clear and navigable when the user switches between languages.`}</p>
    <p>{`They should also be able to input special characters or alphabets from other languages without causing malfunctions.`}</p>
    <h3 {...{
      "id": "modal-dialog"
    }}>{`Modal dialog`}</h3>
    <p>{`Avoid using dialog boxes that interrupt the user’s workflow, except in important situations.`}</p>
    <p>{`For example, use the in-panel UI to display things like success messages, rather than a dialog box.`}</p>
    <h3 {...{
      "id": "icons"
    }}>{`Icons`}</h3>
    <p>{`Use unique icons to represent the add-on itself, and the features within it. Consider working with a designer to create icons that are clear and distinct.`}</p>
    <h2 {...{
      "id": "using-adobe-icons-and-phrasing"
    }}>{`Using Adobe icons and phrasing`}</h2>
    <p>{`Follow these guidelines to make sure you are referring to Adobe correctly in your add-on.`}</p>
    <p>{`For more information on using Adobe brand assets, check our `}<a parentName="p" {...{
        "href": "../brand_guidelines.md"
      }}>{`Developer Brand Guidelines`}</a>{`.`}</p>
    <h2 {...{
      "id": "referring-to-add-ons"
    }}>{`Referring to add-ons`}</h2>
    <p>{`Always use the spelling "add-on", NOT "addon" or "plugin".`}</p>
    <h2 {...{
      "id": "referring-to-adobe-express"
    }}>{`Referring to Adobe Express`}</h2>
    <p>{`Always use the full name "Adobe Express" when referring to the tool. Do not shorten it to "Express".`}</p>
    <h2 {...{
      "id": "using-adobe-icons"
    }}>{`Using Adobe Icons`}</h2>
    <p>{`We allow and encourage you to use the workflow and UI icons in Spectrum Design within your add-on. However, you must not use any Adobe branding elements, such as the Adobe logo or the "Premium" crown icon for paid items.`}</p>
    <h2 {...{
      "id": "referring-to-stock-photos"
    }}>{`Referring to stock photos`}</h2>
    <p>{`If your copy includes any mention of stock content or assets within Adobe Express, you must refer to it with a lower case "s" (ie. stock).`}</p>
    <p>{`This avoids confusion with Adobe Stock, which is a separate service.`}</p>
    <p>{`For example:`}</p>
    <p><strong parentName="p"><em parentName="strong">{`"Discover a wide range of high-quality stock photos in Adobe Express"`}</em></strong></p>
    <h2 {...{
      "id": "localization"
    }}>{`Localization`}</h2>
    <p>{`All add-ons must provide support for the English language. In addition, you are welcome to create your add-on in any other supported language.`}</p>
    <h2 {...{
      "id": "functionality-for-multilingual-ui"
    }}>{`Functionality for Multilingual UI`}</h2>
    <p>{`You must test your add-on to make sure that the user interface remains intact and functional when you switch between any supported languages.`}</p>
    <h2 {...{
      "id": "text-display"
    }}>{`Text display`}</h2>
    <p>{`Ensure that changing the language does not result in add-on strings or text content being cut-off or truncated. All text should be visible and displayed appropriately on the add-on in all supported languages.`}</p>
    <h2 {...{
      "id": "branding-your-add-ons-for-monetization"
    }}>{`Branding your add-ons for monetization`}</h2>
    <p>{`When building your checkout experience to monetize your add-ons, you can use the approved colors, gradients, and iconography to communicate when content or features in your add-on require purchase and when content or features are paid and unlocked.`}</p>
    <p>{`Carefully review our `}<a parentName="p" {...{
        "href": "../monetization.md#branding-your-add-ons-for-monetization"
      }}>{`monetization brand guidelines`}</a>{` to get the latest information on Adobe’s recommendations on branding your add-ons for monetization.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      